<script lang="ts">
    import { cx } from '$lib/utils/cx';
    import MenuLink from '$components/ButtonMenu/MenuLink.svelte';
    import ButtonMenu from '$components/ButtonMenu/ButtonMenu.svelte';
    import { createModal } from '$components/Modal.svelte';
    import ModalGoafricaContact from '$components/GoafricaContact/ModalGoafricaContact.svelte';
    import {
        createForm,
        partialFromCurrentUser,
    } from '$components/GoafricaContact/GoafricaContactFormData';
    import uniqueId from 'lodash/uniqueId';
    import { getContainer } from '$components/Context/ContainerContext';

    export let companyId: number;

    const { currentUserStore } = getContainer();
    let currentUser = currentUserStore().currentUser();

    const modal = createModal({});

    let actions = {
        edit: {
            type: 'async' as const,
            action: async () => {
                modal.states.open.set(true);

                return {
                    type: 'success' as const,
                };
            },
        },
    };

    const [form, fields] = createForm(
        `${uniqueId(`goafrica-contact-${companyId}`)}`,
        {
            subject: 'report_company',
            to: 'administration',
            relatedCompanyId: companyId,
            ...partialFromCurrentUser($currentUser),
        },
        {
            withCompanyNameRequired: false,
            withPhoneRequired: false,
            withSubject: false,
        },
    );

    function syncCurrentUser(currentUser: typeof $currentUser) {
        if (currentUser != null) {
            form.dispatch((state) => {
                return form.actions().changeValues({
                        ...state.values,
                        ...partialFromCurrentUser(currentUser),
                    }, [])(state);
            });
        }
    }

    $: syncCurrentUser($currentUser);
</script>

<ButtonMenu
    class={cx('w-full h-full text-14 bg-white hover:bg-gray-100 px-12')}
    ariaLabel={'Autres actions'}
    {actions}
>
    <i slot="button" class="fa fa-ellipsis-v" aria-hidden={true}></i>

    <svelte:fragment slot="menu">
        <MenuLink icon="fa fa-exclamation-triangle mr-3" key="edit">
            Signaler la société
        </MenuLink>
    </svelte:fragment>
</ButtonMenu>

<ModalGoafricaContact
    {form}
    {fields}
    {modal}
    prefixId={`${uniqueId(`goafrica-contact-${companyId}`)}`}
    currentUser={$currentUser}
    messageLabel={'Raison du signalement'}
    modalTitle={'Signaler une société'}
    withCompanyNameRequired={false}
    withPhoneRequired={false}
    onSuccess={() => {
        modal.states.open.set(false);
    }}
/>
